import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})

export class AppointmentTypeService {

  constructor(private http: HttpClient) { }

  saveAppointment(id: any, payload: any) {
    if (id) {
      return this.http.patch(urls.API_URL + urls.APPOINTMENT_TYPES + `/${id}`, payload)
        .pipe(catchError(errorHandl));
    }
    return this.http.post(urls.API_URL + urls.APPOINTMENT_TYPES, payload)
      .pipe(catchError(errorHandl));
  }

  getAppointment(queryParams?: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.APPOINTMENT_TYPES, { params })
      .pipe(catchError(errorHandl));
  }

  getPicker(queryParams?: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.APPOINTMENT_TYPES + urls.PICKER, { params })
      .pipe(catchError(errorHandl));
  }

  getAppointmentById(id: any) {
    return this.http.get(urls.API_URL + urls.APPOINTMENT_TYPES + `/${id}`)
      .pipe(catchError(errorHandl));
  }
}
